export default __webpack_public_path__ + "static/media/temperature_dark_icon.16269712.svg";